import { Component, OnInit, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FoodService } from 'app/services';

@Component({
    selector: 'edit-restaurant',
    templateUrl: './edit-restaurant.component.html',
    styleUrls: ['./edit-restaurant.component.scss'],
    providers: [MessageService]
})
export class EditRestaurantComponent implements OnInit {
    @Input()
    public restaurantId: number = 0;

    @Input()
    public onSave: () => void = () => { };

    @Input()
    public onHide: () => void = () => { };

    public restaurant: any = {};

    constructor(
        private messageService: MessageService,
        private foodService: FoodService) {
    }

    ngOnInit(): void {
        if (this.restaurantId) {
            this.getRestaurant();
        }
    }

    private getRestaurant(): void {
        const dto = {
            Id: this.restaurantId
        };

        this.foodService.getRestaurantById(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.restaurant = data;
            });
    }

    public handleUploadClick(): void {
        document.getElementById('idImgInput')?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.restaurant.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public handleSideBarHide(): void {
        this.onHide();
    }

    public handleSaveClick(): void {
        let promise: Promise<any> = Promise.resolve();

        if (this.restaurantId) {
            promise = this.foodService.updateRestaurant(this.restaurant, this.messageService);
        } else {
            promise = this.foodService.addRestaurant(this.restaurant, this.messageService);
        }

        promise.then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }

            this.onSave();
        });
    }
}
